module.exports = __webpack_public_path__ + "media/src/assets/international_dog-f387a0eab695c9a8af25a98597df6957.jpg";